<template>
  <div class="rotate-frame"><slot></slot></div>
</template>

<script>
// 让内部竖屏页面在“横屏设备”上旋转 90° 铺满屏幕（实际仍是横屏，只是内容转成竖屏）。
// 旋转方向为逆时针（-90deg）：transform-origin:0 0; top:100%; left:0;
// 宽=100vh 高=100vw，旋转后正好铺满横屏视口。
// （PortraitMode.vue / AppMain.vue 用的是顺时针 90deg + left:100%，方向相反。）
export default {
  name: 'RotateFrame'
}
</script>

<style scoped>
/* 竖屏设备：透明包裹，不旋转，内部页面照常按竖屏铺满 */
.rotate-frame {
  display: contents;
}

/* 横屏设备：整块内容逆时针旋转 90° 变成竖屏条，铺满横屏视口 */
@media screen and (orientation: landscape) {
  .rotate-frame {
    display: block;
    position: fixed;
    top: 100%;
    left: 0;
    transform-origin: 0 0;
    transform: rotate(-90deg);
    width: 100vh;   /* 旋转后为视觉高度 → 铺满屏幕高度 */
    width: 100dvh;  /* 移动端动态视口，避开状态栏/浏览器栏 */
    height: 100vw;  /* 旋转后为视觉宽度 → 铺满屏幕宽度 */
    height: 100dvw;
    overflow: hidden;
    z-index: 1;
  }
}
</style>
